import React, { Component } from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import { iv } from './iv';
import { cp } from './cp';

import cView from './cView';

class cUserDtl extends cView {

  $id_stgs = {
    b_useCm11: false,
    b_useCm12: false,
  };

  $cd_stss = {
    //
    s_cm10b21k: '', // 利用者グループcm20_key
    s_cm10c310: '', // 氏名・名称
    s_cm10c320: '', // フリガナ
    s_cm10c330: '', // ニックネーム・源氏名
    s_cm10c410: '', // 利用者区分
    s_cm10cz10: '', // 表示区分
    s_cm10i110: '', // メール
    //
    s_cm11i110: '',
    s_cm11i120: '',
    s_cm11i130: '',
    s_cm11i210: '', // 生年月日
    //
    s_cm12i210: '',
    s_cm12i220: '',
    s_cm12i230: '',
    s_cm12i240: '',
    s_cm12i250: '',
    s_cm12i260: '',
    s_cm12i270: '',
  };

  $clp_loads = () => [
    new Promise( _o_end1 => {
      cp.$cp_load_cm10({
        b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
        mode: 'set',
  //      cm10_key: global.c?.state.sgcd_pageCmns?.cm10_key,
        cm10_key: global.c?.state.sgcd_pageCmns?.cm10_key,
      })
      .then( _d_cm10s => {
        if (bf.f(_d_cm10s)) {
          cf.myRN_setCmns({
            cm10_pfx: (_d_cm10s.cm10c330) ? _d_cm10s.cm10c330 : (_d_cm10s.cm10c310 || ''),
          })
          .then(() => {
            _o_end1();
          });
        }
        else {
          _o_end1();
        };
      });
    }),
    new Promise( _o_end1 => { // 利用者属性情報 #1
      //
      if (
        global.c?.$id_stgs.b_useCm11 == true &&
        global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show'
      ) {
        let _cnd = bf.q('[cm11b11k]="{}"'.f(
//          global.c?.state.sgcd_pageCmns?.cm10_key,
          global.c?.state.sgcd_pageCmns?.cm10_key,
        ));
//bf.l('59:{}'.f(_cnd));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'cm11', 
          n_dms: 2, 
          cnd: _cnd
        }) // pageKey ではなく pagePntKey
        .then((_d_cm11s) => {
          //
          global.c?.setState({
            s_cm11i110: _d_cm11s.cm11i110 || '',
            s_cm11i120: _d_cm11s.cm11i120 || '',
            s_cm11i130: _d_cm11s.cm11i130 || '',
            s_cm11i210: _d_cm11s.cm11i210 || '',
          }, ()=>{
            _o_end1();
          })
        })
      }
      else {
        _o_end1();
      };
    }),
    new Promise( _o_end1 => { // 利用者属性情報 #2
      //
      if (
        global.c?.$id_stgs.b_useCm12 == true &&
        global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'show'
      ) {
        let _cnd = bf.q('[cm12b11k]="{}"'.f(
//          global.c?.state.sgcd_pageCmns?.cm10_key,
          global.c?.state.sgcd_pageCmns?.cm10_key,
        ));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'cm12', 
          n_dms: 2, 
          cnd: _cnd
        }) // pageKey ではなく pagePntKey
        .then((_d_cm12s) => {
          //
          global.c?.setState({
            s_cm12i210: _d_cm12s.cm12i210 || '',
            s_cm12i220: _d_cm12s.cm12i220 || '',
            s_cm12i230: _d_cm12s.cm12i230 || '',
            s_cm12i240: _d_cm12s.cm12i240 || '',
            s_cm12i250: _d_cm12s.cm12i250 || '',
            s_cm12i260: _d_cm12s.cm12i260 || '',
            s_cm12i270: _d_cm12s.cm12i270 || '',
          }, ()=>{
            _o_end1();
          })
        })
      }
      else {
        _o_end1();
      };
    }),
  ];

  $clp_bfrIuds = () => [
    new Promise( _o_end1 => { // 同一のメールアドレスの存在チェック
      if (!bf.f(global.c?.state.s_cm10i110)) {
        alert('メールアドレスを指定してください')
        _o_end1(false);
      }
      else {
        let _cnd = '';
        if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') {
          _cnd = bf.q('[cm10b21k]="{}" AND [cm10i110]="{}"'.f(
            global.c?.state.s_cm10b21k, // 同一の店舗でなければ、登録を許容する
            bf.myCM_cnv('lwr', global.c?.state.s_cm10i110),
          ));
        };
        if (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'edit') {
/*
          _cnd = bf.q('[cm10i110]="{}" AND [_KEY]<>{}'.f(
            global.c?.state.s_cm10i110,
            global.c?.state.sgcd_pageCmns?.cm10_key,
          ));
*/
          _cnd = bf.q('[cm10b21k]="{}" AND [cm10i110]="{}" AND [_KEY]<>{}'.f(
            global.c?.state.s_cm10b21k, // 同一の店舗でなければ、登録を許容する
            bf.myCM_cnv('lwr', global.c?.state.s_cm10i110),
            global.c?.state.sgcd_pageCmns?.cm10_key,
          ));
        }
        cf.myCB_call_slc({
          ctr: 'nlm',
          elm: 'cm10',
          n_dms: 2,
          cnd: _cnd,
        })
        .then( _d_cm10s => {
          if (!bf.f(_d_cm10s)) {
            _o_end1(true);
          }
          else {
            alert('同一の店舗に、同一のメールアドレスが存在するため登録できません')
            _o_end1(false);
          };
        });
      };
    }),
  ];

  $cp_ins = () => new Promise( (_o_end1) => {
//    cf.myRN_user_ins(global.c?.state.s_cm10i110)
    let _eml = bf.myCM_cnv('lwr', global.c?.state.s_cm10i110);
    cf.myRN_user_ins(_eml)
    .then((_d_cm10s)=>{
      cf.myRN_setCmns({
        cm10_key: _d_cm10s._KEY,
      })
      .then(() => {
//        _o_end1(true);
        const _sbj = 'メールアドレス登録完了のお知らせ';
        const _msg = '本メールアドレスにおいて、システム登録・変更が完了したことをお知らせします。';
        cf.myCB_call_eml(_eml, _sbj, _msg)
//        .then(() => {
//          _o_end1(true);
//        });
        _o_end1(true);
      });
    });
  });

  $clp_upds = () => [
//    cp.$cp_upd_cm10(),
    new Promise( _o_end1 => {
      let _eml = bf.myCM_cnv('lwr', global.c?.state.s_cm10i110);
      let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pageCmns?.cm10_key))
      cf.myCB_call_slc({
        ctr: 'nlm', 
        elm: 'cm10',
        n_dms: 2, 
        cnd: _cnd
      })
      .then((_d_cm10s)=>{
        cp.$cp_upd_cm10()
        .then(() => {
          if (_d_cm10s.cm10i110 != _eml) { // eml が変更されている場合
            const _sbj = 'メールアドレス登録完了のお知らせ';
            const _msg = '本メールアドレスにおいて、システム登録・変更が完了したことをお知らせします。';
            cf.myCB_call_eml(_eml, _sbj, _msg)
//            .then(() => {
//              _o_end1();
//            });
            _o_end1();
          }
          else {
            _o_end1();
          };
        });
      });
    }),
    new Promise( _o_end1 => { // 利用者属性情報#1
      //
      if (global.c?.$id_stgs.b_useCm11 == true) {
        //
        let _d_vals = {
//          cm11b11k: global.c?.state.sgcd_pageCmns?.cm10_key,
          cm11b11k: global.c?.state.sgcd_pageCmns?.cm10_key,
          cm11i110: global.c?.state.s_cm11i110 || '',
          cm11i120: global.c?.state.s_cm11i120 || '',
          cm11i130: global.c?.state.s_cm11i130 || '',
          cm11i210: global.c?.state.s_cm11i210 || '',
        }
//        let _cnd = bf.q('[cm11b11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm10_key))
        let _cnd = bf.q('[cm11b11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm10_key))
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: 'cm11', 
          d_vals: _d_vals, 
          cnd: _cnd
        })
        .then((_d_res)=>{
          _o_end1();
        });
      }
      else {
        _o_end1();
      };
    }),
    new Promise( _o_end1 => { // 利用者属性情報#2
      //
      if (global.c?.$id_stgs.b_useCm12 == true) {
        //
        let _d_vals = {
//          cm12b11k: global.c?.state.sgcd_pageCmns?.cm10_key,
          cm12b11k: global.c?.state.sgcd_pageCmns?.cm10_key,
          cm12i210: global.c?.state.s_cm12i210 || '',
          cm12i220: global.c?.state.s_cm12i220 || '',
          cm12i230: global.c?.state.s_cm12i230 || '',
          cm12i240: global.c?.state.s_cm12i240 || '',
          cm12i250: global.c?.state.s_cm12i250 || '',
          cm12i260: global.c?.state.s_cm12i260 || '',
          cm12i270: global.c?.state.s_cm12i270 || '',
        };
//        let _cnd = bf.q('[cm12b11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm10_key))
        let _cnd = bf.q('[cm12b11k]="{}"'.f(global.c?.state.sgcd_pageCmns?.cm10_key))
        cf.myCB_call_iud({
          ctr: 'ups', 
          elm: 'cm12', 
          d_vals: _d_vals, 
          cnd: _cnd
        })
        .then((_d_res)=>{
          _o_end1();
        });
      }
      else {
        _o_end1();
      };
    }),
  ];

  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={{
          pfx: iv._get_hdrPfx('ユーザ情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm10i110',
              pfx:'メール',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm10c310',
              pfx:'名前',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm11i130',
              pfx:'電話番号',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm12i210',
              pfx:'振込先銀行コード',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm12i220',
              pfx:'振込先銀行名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm12i230',
              pfx:'振込先支店コード',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm12i240',
              pfx:'振込先支店名',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm12i250',
              pfx:'振込先口座種別',
              dd_listItemss:{
                '10':{key:'10', pfx: '普通'},
                '20':{key:'20', pfx: '当座'},
              },
              b_setValOnChg:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm12i260',
              pfx:'振込先口座番号',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm12i270',
              pfx:'振込先口座名',
              b_mln:false,
            },
            {
              type:'Pck',
//              b_vsb:(ic.gb_dbg || global.c?.state.sgc_cm10_key == -1 || bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90'])) ? true : false,
              b_vsb:(bf.n(global.c?.state.sgcd_pageCmns?.user_key) == -1 || bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm10c410',
              pfx:'利用者区分 ※運営者のみ表示',
              dd_listItemss:{
                  '10':{key:'10', pfx: '会員'},
                  '90':{key:'90', pfx: '運営者'},
              },
              b_setValOnChg:false,
            },
            {
              type:'Pck',
//              b_vsb:(bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90'])) ? true : false,
              b_vsb:(bf.i(global.c?.state.sgcd_userCmns?.userc410, ['90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm10cz10',
              pfx:'表示の有無　※運営者のみ表示',
              dd_listItemss:{
                  '10':{key:'10', pfx: '表示する'},
                  '0':{key:'0', pfx: '表示しない'},
              },
            },
          ],
        }}
      />
    );
  };
};

export default cUserDtl;
